const userConstants = {
    LOGIN: 'LOGIN',
    LOGOUT: 'LOGOUT'
};

export default userConstants;
